<template>
  <router-view></router-view>
</template>

<script>
import "./assets/global.css";
import "./assets/markdown.less";
import "highlight.js/styles/github.css";
export default {};
</script>
